import request from '@/http/request'
import {
  readUserPrivilege
} from '@/http/api'

export const getCommonInfo = () => {
  return request({
    url: readUserPrivilege
  })
}